"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Header = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var EditorIssueLevel = ui_common_1.commonEnums.EditorIssueLevel;
var IconCell = function (_a) {
    var iconName = _a.iconName, iconClass = _a.iconClass;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "qa-scrubber-issues scrubber-issues col-evidence code-indicator-cell" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "indicator" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "".concat(iconName), svgIconSize: "20", svgIconClass: "".concat(iconClass) }) })) })));
};
/**
 * React component that displays a Header
 * @param medicalCode
 * @param errors
 * @param handleKeyPress
 * @param handleBlurEvent
 * @param handleUnitsClick
 * @param handleCodeDelete
 * @param handleEnableTechPro
 * @param handleDisableTechPro
 * @returns
 */
var Header = function (medicalCode, techTransaction, errors, invoice, codeEdits, handleKeyPress, handleBlurEvent, handleUnitsClick, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, isTimeBasedCode, timeBasedCodePopup) {
    var _a;
    var _b, _c, _d, _e;
    if (ui_common_1.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "transaction-header icd-code transaction-shared-code-list" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "move-column" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-gripper prevent-click" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeGripperSVG20", svgIconSize: "20", svgIconClass: "gripper" }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "codes-column" }, { children: medicalCode.codes.map(function (medicalCode, idx) {
                        var active = medicalCode.active;
                        var classes = (0, classnames_1["default"])([
                            'chip',
                            {
                                'shared-code-on': active,
                                'shared-code-off': !active
                            }
                        ]);
                        // change icon here... turned off for now.
                        var iconName = active ? 'BiomeCheckSVG20' : 'BiomeMinusSVG20';
                        return ((0, jsx_runtime_1.jsx)("span", __assign({ className: "icd-code unclickable prevent-click", "data-dd-action-name": active === true ? '~Toggle code off' : '~Toggle code on' }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-chip" }, { children: (0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", style: { display: 'none' }, name: "".concat(medicalCode.code), onClick: handleCodeChecked, className: "txn-shared-checkbox", defaultChecked: active }), active && ((0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: iconName, svgIconSize: "20", svgIconClass: "shared-icon" })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-text" }, { children: medicalCode.code }))] })) }) })) }), medicalCode.code));
                    }) }))] })));
    }
    else if (ui_common_1.cmxTypeguards.isChargeSessionCode(medicalCode)) {
        //@ts-ignore
        var shared = (_b = medicalCode.shared) !== null && _b !== void 0 ? _b : false;
        var sharedInvoice = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES;
        var uneditableSharedCode = shared && !sharedInvoice;
        var allEdits = (_c = codeEdits[medicalCode.code]) !== null && _c !== void 0 ? _c : [];
        var vwErrors = allEdits.some(function (edit) { return edit.level === EditorIssueLevel.ERROR; });
        var vwWarnings = allEdits.some(function (edit) { return edit.level === EditorIssueLevel.WARNING; });
        var styleClasses = [
            "transaction-header",
            (_a = {
                    'code-errors': errors.some(function (error) {
                        return (error.message_key === 'procedure_code.units.invalid' &&
                            medicalCode.codeType === 'procedure') ||
                            error.message_key !== 'procedure_code.units.invalid';
                    }),
                    unitable: medicalCode.unitable,
                    editable: medicalCode.editable,
                    'uneditable-shared-code': uneditableSharedCode
                },
                _a['transaction-shared-code'] = shared,
                _a),
            "".concat(medicalCode.provenance.toLowerCase(), "-code")
        ];
        var evidence = (_d = medicalCode.evidence) !== null && _d !== void 0 ? _d : [];
        var hasEvidence = (_e = evidence.length > 0) !== null && _e !== void 0 ? _e : false;
        var description = medicalCode.description || 'Retrieving description...';
        var codeUnitsStyle = [
            'code-units-input',
            {
                'procedure-code-units-invalid': errors.some(function (error) { return error.message_key === 'procedure_code.units.invalid'; })
            }
        ];
        var showActionsColumn = vwErrors ||
            vwWarnings ||
            hasEvidence ||
            techTransaction.hasTechCode ||
            techTransaction.hasProCode;
        var proClassName = (0, classnames_1["default"])([
            'pro-tech-box',
            {
                'is-active': techTransaction.isProCodeActive,
                'is-inactive': !techTransaction.isProCodeActive,
                'single-box': !techTransaction.hasTechCode,
                'left-box': techTransaction.hasTechCode
            }
        ]);
        var techClassName = (0, classnames_1["default"])([
            'pro-tech-box',
            {
                'is-active': techTransaction.isTechCodeActive,
                'is-inactive': !techTransaction.isTechCodeActive,
                'single-box': !techTransaction.hasProCode,
                'right-box': techTransaction.hasProCode
            }
        ]);
        var techIndicatorClassName = (0, classnames_1["default"])([
            'qa-tech-indicator',
            'prevent-click',
            'tech-indicator',
            'indicator',
            'indicator-pro-tech',
            {
                'tech-indicator-no-space': (techTransaction.hasProCode && techTransaction.isTechCodeActive) ||
                    (techTransaction.hasTechCode && techTransaction.isProCodeActive),
                'indicator-pro-tech-active': techTransaction.isTechCodeActive,
                'indicator-pro-tech-inactive': !techTransaction.isTechCodeActive,
                'single-indicator-pro-tech': !techTransaction.hasProCode,
                'indicator-pro-tech-modifier': techTransaction.isModifier,
                'indicator-pro-tech-no-modifier': !techTransaction.isModifier,
                'pro-tech-loading': techTransaction.isLoading
            }
        ]);
        var proIndicatorClassName = (0, classnames_1["default"])([
            'qa-pro-indicator',
            'prevent-click',
            'pro-indicator',
            'indicator',
            'indicator-pro-tech',
            {
                'indicator-pro-tech-active': techTransaction.isProCodeActive,
                'indicator-pro-tech-inactive': !techTransaction.isProCodeActive,
                'single-indicator-pro-tech': !techTransaction.hasTechCode,
                'indicator-pro-tech-modifier': techTransaction.isModifier,
                'indicator-pro-tech-no-modifier': !techTransaction.isModifier,
                'pro-tech-loading': techTransaction.isLoading
            }
        ]);
        var proCheck = (0, classnames_1["default"])([
            'pro-tech-check',
            {
                'pro-tech-check-active': techTransaction.isProCodeActive,
                'pro-tech-check-inactive': !techTransaction.isProCodeActive
            }
        ]);
        var techCheck = (0, classnames_1["default"])([
            'pro-tech-check',
            {
                'pro-tech-check-active': techTransaction.isTechCodeActive,
                'pro-tech-check-inactive': !techTransaction.isTechCodeActive
            }
        ]);
        var toggleProCode = function () {
            if (!techTransaction.isLoading) {
                techTransaction.isProCodeActive
                    ? handleEnableTechPro(techTransaction.proContext)
                    : handleDisableTechPro(techTransaction.proContext);
            }
        };
        var toggleTechCode = function () {
            if (!techTransaction.isLoading) {
                techTransaction.isTechCodeActive
                    ? handleEnableTechPro(techTransaction.techContext)
                    : handleDisableTechPro(techTransaction.techContext);
            }
        };
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-code": "".concat(medicalCode.code), "data-code-type": "".concat(medicalCode.codeType), className: (0, classnames_1["default"])(styleClasses) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "units-column" }, { children: medicalCode.codeType !== 'procedure' ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: "code-gripper prevent-click" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeGripperSVG20", svgIconSize: "20", svgIconClass: "gripper" }) }))) : ((0, jsx_runtime_1.jsx)("span", __assign({ className: "code-units-populateable prevent-click" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "case-units-numeral" }, { children: (0, jsx_runtime_1.jsx)("input", { onInput: handleKeyPress, onBlur: handleBlurEvent, onClick: handleUnitsClick, type: "text", disabled: !medicalCode.editable, className: (0, classnames_1["default"])(codeUnitsStyle), value: medicalCode.units }) })) }))) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "codes-column" }, { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: "code-chip" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "chip" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-text" }, { children: medicalCode.code })) })), !uneditableSharedCode && ((0, jsx_runtime_1.jsx)("span", __assign({ onClick: handleCodeDelete, className: "code-action-icon code-delete-icon chip" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "code-action-icon-inner code-delete" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "#/delete-code", className: "code-delete-link" }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeCancelSVG20", svgIconSize: "12" }) })) })) })))] })) })), (0, jsx_runtime_1.jsx)("div", __assign({ title: description, className: "qa-description-column description-column" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "ellipsify" }, { children: description })) })), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: medicalCode.codeType === 'procedure' &&
                        isTimeBasedCode() &&
                        timeBasedCodePopup() }), showActionsColumn && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "code-actions-column" }, { children: [hasEvidence && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-evidence code-indicator-cell" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "indicator" }, { children: "CMX" })) }))), vwErrors && ((0, jsx_runtime_1.jsx)(IconCell, { iconName: "BiomeVWErrorSVG20", iconClass: "qa-issue-error alert-error" })), /**
                         * you can have errors and warnings at the same time.
                         * due to the way react code is structured, i really don't like
                         * nested ternary operators in jsx, hence the !vwErrors
                         */ !vwErrors && vwWarnings && ((0, jsx_runtime_1.jsx)(IconCell, { iconName: "BiomeVWWarningSVG20", iconClass: "qa-issue-warning alert-warning" })), (techTransaction.hasTechCode || techTransaction.hasProCode) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [techTransaction.hasProCode && ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(proIndicatorClassName), onClick: toggleProCode }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: proClassName }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeCheckSVG20", svgIconSize: "12", svgIconClass: (0, classnames_1["default"])(proCheck) }), (0, jsx_runtime_1.jsx)("p", __assign({ className: "pro-tech-label" }, { children: "P" }))] })) }))), techTransaction.hasTechCode && ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(techIndicatorClassName), onClick: toggleTechCode }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: techClassName }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeCheckSVG20", svgIconSize: "12", svgIconClass: (0, classnames_1["default"])(techCheck) }), (0, jsx_runtime_1.jsx)("p", __assign({ className: "pro-tech-label" }, { children: "T" }))] })) })))] }))] })))] }), "".concat(medicalCode.code, "-").concat(medicalCode.codeType)));
    }
};
exports.Header = Header;
//# sourceMappingURL=transaction-header.js.map